import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as dot from 'dot-wild';

/**
 *
 */
@Injectable()
export class R10FilterService {
	getProductChartLegendFormatter = function (): string {
		return `<span style='color:${this['color']}'>${this.name}</span>`;
	};

	getChartYaxisFormatter = function (): string {
		return Highcharts.numberFormat(this.value, 0, '', ',');
	};

	evaluateJsonValuesUsingStringPath(customConfiguration: any): object {
		let config = customConfiguration;
		Object.keys(config.customMethods).forEach((methodKey) => {
			config = dot.set(config, methodKey, this[config.customMethods[methodKey]]);
		});
		return config;
	}
}
